"use client";

import { ENUM_ICONS, resolveColorHex } from "@/components/debug/enrichment-display-config";
import {
  SchemaRenderer,
  type FieldGroup,
  type SchemaDisplayConfig,
} from "@/components/debug/SchemaRenderer";
import enrichmentSchema from "@/generated/enrichment-schema.json";

const FIELD_GROUPS: FieldGroup[] = [
  { label: "Identity", fields: ["type", "type_synonyms", "summary"] },
  { label: "Classification", fields: ["gender", "age_groups", "is_activewear"] },
  { label: "Style", fields: ["tags", "styles"] },
  { label: "Colors", fields: ["color", "color_family"] },
  {
    label: "Taxonomy",
    fields: ["category_path", "structured_attributes"],
  },
  { label: "Brand", fields: ["brand_id", "canonical_brand"] },
  { label: "Image", fields: ["image_with_single_product"] },
];

const DISPLAY_CONFIG: SchemaDisplayConfig = {
  enumIcons: ENUM_ICONS,
  colorFields: new Set(["color", "color_family"]),
  resolveColorHex,
};

interface EnrichmentRendererProps {
  data: Record<string, unknown>;
}

export function EnrichmentRenderer({ data }: EnrichmentRendererProps) {
  return (
    <SchemaRenderer
      schema={enrichmentSchema}
      data={data}
      fieldGroups={FIELD_GROUPS}
      displayConfig={DISPLAY_CONFIG}
    />
  );
}
